import * as React from 'react';
import { UIText1, UIText2 } from '@cian/ui-kit';
import classNames from 'clsx';

import * as styles from './styles.css';
import { SalesStartTooltip } from '../../../SalesStartTooltip';

interface IHouseItemProps {
  active: boolean;
  title: string;
  finishStatus?: string;
  isSalesStart?: boolean;
}

export function HouseItem({ active, title, finishStatus, isSalesStart = false }: IHouseItemProps) {
  return (
    <div className={classNames(styles['container'], active && styles['active'])}>
      <div className={styles['title']}>
        <UIText1>{title}</UIText1>
        <div className={styles['labels']}>{isSalesStart && <SalesStartTooltip />}</div>
      </div>
      {finishStatus && <UIText2 color="text-secondary-default">{finishStatus}</UIText2>}
    </div>
  );
}
